import { Component, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

interface TimepickerModel {
  hour: string;
  min: string;
}

@Component({
  selector: 'app-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TimepickerComponent),
    multi: true
  }]
})
export class TimepickerComponent implements ControlValueAccessor {

  private dataValue: string;

  get value() {
    return this.dataValue;
  }

  set value(data: string) {
    if (data != null) {
      this.processTimeInput(data);
      this.onChangeTimepicker(data);
      this.dataValue = data;
    }
  }

  @Input() public id: string;
  @Input() public label: string;
  @Input() public placeholder: string;
  @Input() public disabled = false;
  @Input() public showClearBtn = false;
  @Input() public isWidth = false;

  @Output() public selectValue: EventEmitter<string> = new EventEmitter();
  @Output() public clearEmit: EventEmitter<void> = new EventEmitter();

  public showSelector: boolean;

  // tslint:disable-next-line: max-line-length
  public hourOpts = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
  // tslint:disable-next-line: max-line-length
  public minuteOpts = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'];

  public innerValue: TimepickerModel = {
    hour: null,
    min: null
  };

  public processTimeInput(data: any): void {
    this.innerValue.hour = data.slice(0, 2);
    this.innerValue.min = data.slice(3);
  }

  public toggleSelector(event: MouseEvent): void {
    event.stopPropagation();
    if (this.disabled) {
      this.showSelector = false;
      return;
    }
    this.showSelector = !this.showSelector;
  }

  public hourSelect(idx: number): void {
    this.innerValue.hour = this.hourOpts[idx];
  }

  public minuteSelect(idx: number, event: MouseEvent): void {
    this.innerValue.min = this.minuteOpts[idx];
    this.selection(event);
  }

  public selection(event: MouseEvent): void {
    if (this.innerValue.hour && this.innerValue.min) {
      this.selectValue.emit(`${this.innerValue.hour}:${this.innerValue.min}`);
      this.toggleSelector(event);
    }
  }

  clearInput() {
    this.clearEmit.emit();
  }

  writeValue(newValue: string): void {
    this.value = newValue;
  }

  registerOnChange(fn: (_: string) => void): void {
    this.onChangeTimepicker = fn;
  }

  onChangeTimepicker: (_: string) => void = () => { };

  registerOnTouched(fn: (_: string) => void): void {
    this.onTouchedTimepicker = fn;
  }

  onTouchedTimepicker: (_: string) => void = () => { };
}
